import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-20 flex items-center semi-transparent" }
const _hoisted_3 = {
  style: {"font-size":"18.5px !important"},
  class: "material-icons"
}
const _hoisted_4 = { class: "absolute bottom-0 right-0 z-20 semi-transparent" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "expand_more", -1)
const _hoisted_6 = { class: "overflow-hidden rounded-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_highlightjs = _resolveComponent("highlightjs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Btn, {
        variant: 'icon',
        outline: true,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDark(!_ctx.dark))),
        class: _normalizeClass({ 'text-lightText': _ctx.dark })
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dark ? "light_mode" : "dark_mode"), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      (!_ctx.useDefault)
        ? (_openBlock(), _createBlock(_component_CopyToClipboard, {
            key: 0,
            class: _normalizeClass({ 'text-lightText': _ctx.dark }),
            "icon-only": true,
            value: _ctx.value,
            tooltip: _ctx.$t('misc.copy')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass([{ 'text-lightText': _ctx.dark }, "material-icons-outlined"]),
                style: {"font-size":"16px !important"}
              }, " content_copy ", 2)
            ]),
            _: 1
          }, 8, ["class", "value", "tooltip"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.collapsible && _ctx.isTruncated)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            variant: 'icon',
            outline: true,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = true))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_highlightjs, {
        autodetect: "",
        code: _ctx.useDefault ? _ctx.defaultValue : _ctx.processedValue
      }, null, 8, ["code"])
    ])
  ]))
}